import { Client, Task, Product, App, CreditRepairClient, IdTheftClient, CreditDevelopmentClient } from '../types';
import { User, UserInvitation, AuditLog, RoleTemplate } from '../types/user';
import { FieldConfig, SectionConfig, TabConfig, UIConfigChangeLog } from '../types/uiConfig';

export const mockData = {
  clients: [
    {
      id: '1',
      name: 'John Smith',
      segment: 'Premium',
      status: 'Active',
      owner: 'Sarah Johnson',
      riskTier: 'Medium',
      lastContact: '2025-09-15',
      products: ['Credit Repair', 'Credit Monitoring'],
      representative: 'Sarah Johnson',
      contact: { email: 'john.smith@email.com', phone: '(555) 123-4567' },

      // Comprehensive client information
      accountName: 'John & Mary Smith Family Account',
      accountOwner: 'John Smith',
      spouse: 'Mary Smith',
      phone: '(555) 123-4567',
      mobilePhone: '(555) 123-9999',
      birthday: '1985-06-15',
      ssn: '123-45-6789',
      teamEmail: 'team@regalcredit.com',
      email: 'john.smith@email.com',
      emailCCs: ['mary.smith@email.com', 'notifications@smithfamily.com'],
      estimatedNetWorth: 750000,
      annualSalary: 125000,
      employer: 'Tech Solutions Inc',
      serviceManagement: 'Regal Credit Services',
      accountManager: 'Sarah Johnson',
      accountManagerCompany: 'Regal Credit',
      dayToDayContact: 'Sarah Johnson'
    },
    {
      id: '2',
      name: 'Maria Garcia',
      segment: 'Standard',
      status: 'Pending',
      owner: 'Mike Chen',
      riskTier: 'High',
      lastContact: '2025-09-10',
      products: ['ID Theft Recovery'],
      representative: 'Mike Chen',
      contact: { email: 'maria.garcia@email.com', phone: '(555) 234-5678' },

      // Comprehensive client information
      accountName: 'Maria Garcia Individual Account',
      accountOwner: 'Maria Garcia',
      phone: '(555) 234-5678',
      mobilePhone: '(555) 234-8888',
      birthday: '1990-03-22',
      ssn: '987-65-4321',
      teamEmail: 'team@regalcredit.com',
      email: 'maria.garcia@email.com',
      emailCCs: ['garcia.family@email.com'],
      estimatedNetWorth: 85000,
      annualSalary: 55000,
      employer: 'Healthcare Partners',
      serviceManagement: 'Regal Credit Services',
      accountManager: 'Mike Chen',
      accountManagerCompany: 'Regal Credit',
      dayToDayContact: 'Mike Chen'
    },
    {
      id: '3',
      name: 'David Wilson',
      segment: 'Premium',
      status: 'Active',
      owner: 'Lisa Brown',
      riskTier: 'Low',
      lastContact: '2025-09-18',
      products: ['Credit Development', 'Credit Monitoring'],
      representative: 'Lisa Brown',
      contact: { email: 'david.wilson@email.com', phone: '(555) 345-6789' },

      // Comprehensive client information
      accountName: 'David & Jennifer Wilson Joint Account',
      accountOwner: 'David Wilson',
      spouse: 'Jennifer Wilson',
      phone: '(555) 345-6789',
      mobilePhone: '(555) 345-7777',
      birthday: '1978-11-08',
      ssn: '456-78-9012',
      teamEmail: 'team@regalcredit.com',
      email: 'david.wilson@email.com',
      emailCCs: ['jennifer.wilson@email.com', 'wilson.notifications@email.com'],
      estimatedNetWorth: 1250000,
      annualSalary: 195000,
      employer: 'Wilson Engineering LLC',
      serviceManagement: 'Regal Credit Services',
      accountManager: 'Lisa Brown',
      accountManagerCompany: 'Regal Credit',
      dayToDayContact: 'Lisa Brown'
    },
    {
      id: '4',
      name: 'Lisa Brown',
      segment: 'Standard',
      status: 'Active',
      owner: 'Sarah Johnson',
      riskTier: 'Medium',
      lastContact: '2025-09-17',
      products: ['Credit Repair', 'ID Theft Recovery'],
      representative: 'Sarah Johnson',
      contact: { email: 'lisa.brown@email.com', phone: '(555) 456-7890' },

      // Comprehensive client information
      accountName: 'Lisa Brown Individual Account',
      accountOwner: 'Lisa Brown',
      phone: '(555) 456-7890',
      mobilePhone: '(555) 456-1111',
      birthday: '1982-04-12',
      ssn: '789-01-2345',
      teamEmail: 'team@regalcredit.com',
      email: 'lisa.brown@email.com',
      emailCCs: ['l.brown.backup@email.com'],
      estimatedNetWorth: 320000,
      annualSalary: 78000,
      employer: 'Metro Hospital',
      serviceManagement: 'Regal Credit Services',
      accountManager: 'Sarah Johnson',
      accountManagerCompany: 'Regal Credit',
      dayToDayContact: 'Sarah Johnson'
    },
    {
      id: '5',
      name: 'Michael Roberts',
      segment: 'Premium',
      status: 'Pending',
      owner: 'Mike Chen',
      riskTier: 'Low',
      lastContact: '2025-09-19',
      products: ['Credit Development', 'CyberSweep'],
      representative: 'Mike Chen',
      contact: { email: 'michael.roberts@email.com', phone: '(555) 567-8901' },

      // Comprehensive client information
      accountName: 'Michael Roberts Family Trust Account',
      accountOwner: 'Michael Roberts',
      spouse: 'Amanda Roberts',
      phone: '(555) 567-8901',
      mobilePhone: '(555) 567-2222',
      birthday: '1975-12-03',
      ssn: '234-56-7890',
      teamEmail: 'team@regalcredit.com',
      email: 'michael.roberts@email.com',
      emailCCs: ['amanda.roberts@email.com', 'roberts.trust@email.com'],
      estimatedNetWorth: 2100000,
      annualSalary: 275000,
      employer: 'Roberts & Associates Law Firm',
      serviceManagement: 'Regal Credit Services',
      accountManager: 'Mike Chen',
      accountManagerCompany: 'Regal Credit',
      dayToDayContact: 'Mike Chen'
    },
    {
      id: '6',
      name: 'Jennifer Martinez',
      segment: 'Standard',
      status: 'Active',
      owner: 'John Smith',
      riskTier: 'Medium',
      lastContact: '2025-09-16',
      products: ['Credit Repair', 'Credit Monitoring'],
      representative: 'John Smith',
      contact: { email: 'jennifer.martinez@email.com', phone: '(555) 678-9012' },

      // Comprehensive client information
      accountName: 'Jennifer Martinez Individual Account',
      accountOwner: 'Jennifer Martinez',
      primaryParent: 'Carlos Martinez', // Minor account
      phone: '(555) 678-9012',
      mobilePhone: '(555) 678-3333',
      birthday: '2008-07-20',
      ssn: '345-67-8901',
      teamEmail: 'team@regalcredit.com',
      email: 'jennifer.martinez@email.com',
      emailCCs: ['carlos.martinez@email.com', 'maria.martinez@email.com'],
      estimatedNetWorth: 25000,
      annualSalary: 0, // Minor - no salary
      employer: 'Student',
      serviceManagement: 'Regal Credit Services',
      accountManager: 'John Smith',
      accountManagerCompany: 'Regal Credit',
      dayToDayContact: 'John Smith'
    }
  ] as Client[],

  tasks: [
    { id: '1', clientId: '1', title: 'Process credit dispute request', type: 'Credit Repair', status: 'In Progress', priority: 'High', assignee: 'Sarah Johnson', dueDate: '2025-09-20', slaTarget: 2, source: 'Email-to-Case' },
    { id: '2', clientId: '2', title: 'Setup credit monitoring', type: 'Credit Management', status: 'Open', priority: 'Medium', assignee: 'Mike Chen', dueDate: '2025-09-22', slaTarget: 3, source: 'Manual' },
    { id: '3', clientId: '1', title: 'Unlock credit with Experian', type: 'Credit Block', status: 'Completed', priority: 'Low', assignee: 'Lisa Brown', dueDate: '2025-09-18', slaTarget: 1, source: 'Email-to-Case' },
    { id: '4', clientId: '2', title: 'Review client documentation', type: 'ID Theft Recovery', status: 'Open', priority: 'High', assignee: 'John Smith', dueDate: '2025-09-21', slaTarget: 2, source: 'Manual' },
    { id: '5', clientId: '3', title: 'Credit development consultation', type: 'Credit Development', status: 'In Progress', priority: 'Medium', assignee: 'John Smith', dueDate: '2025-09-25', slaTarget: 5, source: 'Phone' },
    { id: '6', clientId: '1', title: 'Follow up on dispute resolution', type: 'Credit Repair', status: 'Completed', priority: 'Low', assignee: 'John Smith', dueDate: '2025-09-15', slaTarget: 3, source: 'Email-to-Case' },
    { id: '7', clientId: '3', title: 'Review credit report updates', type: 'Credit Monitoring', status: 'Open', priority: 'High', assignee: 'John Smith', dueDate: '2025-09-23', slaTarget: 1, source: 'System' }
  ] as Task[],

  products: [
    { id: '1', clientId: '1', name: 'Credit Block', status: 'Active', enrolledDate: '2025-08-15' },
    { id: '2', clientId: '1', name: 'CyberSweep', status: 'Active', enrolledDate: '2025-08-20' },
    { id: '3', clientId: '1', name: 'Credit Management', status: 'Active', enrolledDate: '2025-07-01' }
  ] as Product[]
};

export const apps: App[] = [
  { name: 'Credit Management', description: 'Credit repair, ID theft recovery, and credit development', icon: '💳', color: 'bg-blue-600' },
  { name: 'CyberSweep', description: 'Data broker monitoring and PII protection', icon: '🔍', color: 'bg-purple-600' },
  { name: 'Credit Block', description: 'Credit bureau freeze and monitoring management', icon: '🔒', color: 'bg-green-600' },
  { name: 'System Admin', description: 'Object Manager, Workflows, Security, and system configuration', icon: '⚙️', color: 'bg-amber-600' }
];

export const creditRepairClients: CreditRepairClient[] = [
  { id: 'client_001', name: 'John Smith', status: 'In Progress', initialScore: 580, currentScore: 647, targetScore: 720, improvement: 67, scoreImprovement: 67, creditMonitoring: true },
  { id: 'client_011', name: 'Maria Garcia', status: 'Waiting for Disputes', initialScore: 520, currentScore: 571, targetScore: 680, improvement: 51, scoreImprovement: 51, creditMonitoring: true }
];

export const idTheftClients: IdTheftClient[] = [
  {
    id: 'client_012',
    name: 'Sarah Johnson',
    status: 'Active Investigation',
    fraudulentAccounts: 4,
    lastUpdate: '2025-09-16',
    fraudulentData: [
      { type: 'Credit Card', creditor: 'Bank of America', amount: '$3,250', dateOpened: '2025-07-15', status: 'Disputed' },
      { type: 'Personal Loan', creditor: 'LendingTree', amount: '$8,500', dateOpened: '2025-06-22', status: 'Police Report Filed' },
      { type: 'Auto Loan', creditor: 'Ford Credit', amount: '$24,000', dateOpened: '2025-05-10', status: 'Removed' },
      { type: 'Store Credit', creditor: 'Best Buy', amount: '$1,800', dateOpened: '2025-08-03', status: 'In Progress' }
    ]
  }
];

export const creditDevelopmentClients: CreditDevelopmentClient[] = [
  {
    id: 'client_013',
    name: 'Emily Davis',
    creditHistory: 'No Credit History',
    status: 'Building Credit',
    currentScore: 612,
    targetScore: 650,
    authorizedUserAccounts: 2,
    creditMonitoring: 'Awaiting Setup',
    creditCards: [
      { name: 'Secured Credit Card', status: 'Approved' },
      { name: 'Student Credit Card', status: 'Awaiting Credit Score' },
      { name: 'Rewards Credit Card', status: 'Future Application' }
    ],
    contactInfo: {
      email: 'emily.davis@email.com',
      phone: '(555) 456-7890',
      address: '123 Oak Street',
      city: 'Springfield',
      state: 'IL',
      zipCode: '62701'
    },
    personalInfo: {
      dateOfBirth: '1995-06-15',
      ssn: '123-45-6789',
      employmentStatus: 'Employed Full-Time',
      annualIncome: 45000
    },
    creditScoreHistory: [
      {
        id: '1',
        clientId: '1',
        bureau: 'Experian',
        score: 612,
        date: '2025-09-15',
        reportType: 'Monitoring Update',
        notes: 'First score after adding authorized user accounts',
        createdBy: 'Sarah Johnson',
        createdAt: '2025-09-15T10:30:00Z'
      },
      {
        id: '2',
        clientId: '1',
        bureau: 'Equifax',
        score: 580,
        date: '2025-08-15',
        reportType: 'Soft Pull',
        notes: 'Initial credit check after secured card approval',
        createdBy: 'Sarah Johnson',
        createdAt: '2025-08-15T14:20:00Z'
      },
      {
        id: '3',
        clientId: '1',
        bureau: 'TransUnion',
        score: 595,
        date: '2025-07-01',
        reportType: 'Hard Pull',
        notes: 'Credit application for secured card',
        createdBy: 'Mike Chen',
        createdAt: '2025-07-01T09:15:00Z'
      }
    ],
    tradelines: [
      {
        id: '1',
        accountName: 'Secured Mastercard',
        accountType: 'Credit Card',
        status: 'Open',
        balance: 150,
        creditLimit: 500,
        dateOpened: '2025-07-15',
        paymentHistory: '100% On-Time',
        accountNumber: '****1234',
        creditor: 'Capital One'
      },
      {
        id: '2',
        accountName: 'Auto Loan',
        accountType: 'Auto Loan',
        status: 'Current',
        balance: 12500,
        creditLimit: 15000,
        dateOpened: '2025-06-01',
        paymentHistory: '100% On-Time',
        accountNumber: '****5678',
        creditor: 'Wells Fargo'
      }
    ],
    notes: 'Client is very motivated to build credit. Has been making on-time payments consistently. Considering adding her as authorized user on family member\'s account with excellent payment history. Next goals: Apply for student credit card once current score reaches 620.',
    creditDevelopmentForm: {
      creditDevelopmentStartDate: '2025-07-01',
      creditDevelopmentEndDate: '2025-12-31',
      initialReview: true,
      initialReviewDate: '2025-07-05',
      authorizedUser1: 'Family Member - Chase Sapphire',
      authorizedUser1DateAdded: '2025-07-15',
      securedCardType: 'capital_one_secured',
      creditDevelopmentStage: 'score_improvement',
      amexApplicationType: 'amex_blue_cash_everyday',
      finalReview: false,
      applicationSubmissionDate: '',
      authorizedUser2: '',
      authorizedUser2DateAdded: '',
      authorizedUserSection: {
        authorizedUserStage: 'monitoring_impact',
        authorizedUserStartDate: '2025-07-10',
        authorizedUserEndDate: '2025-10-01'
      }
    }
  },
  {
    id: '2',
    name: 'Marcus Johnson',
    creditHistory: 'Limited Credit',
    status: 'Active',
    currentScore: 645,
    targetScore: 720,
    authorizedUserAccounts: 1,
    creditMonitoring: 'Active',
    creditCards: [
      { name: 'Student Credit Card', status: 'Approved' },
      { name: 'Cash Back Credit Card', status: 'Approved' },
      { name: 'Travel Rewards Card', status: 'Future Application' }
    ],
    contactInfo: {
      email: 'marcus.johnson@email.com',
      phone: '(555) 789-0123',
      address: '456 Maple Avenue',
      city: 'Madison',
      state: 'WI',
      zipCode: '53703'
    },
    personalInfo: {
      dateOfBirth: '1998-03-22',
      ssn: '987-65-4321',
      employmentStatus: 'Student',
      annualIncome: 25000
    },
    creditScoreHistory: [
      {
        id: '4',
        clientId: '2',
        bureau: 'Experian',
        score: 645,
        date: '2025-09-10',
        reportType: 'Monitoring Update',
        notes: 'Score improved after paying down credit card balances',
        createdBy: 'Lisa Brown',
        createdAt: '2025-09-10T11:45:00Z'
      },
      {
        id: '5',
        clientId: '2',
        bureau: 'Equifax',
        score: 628,
        date: '2025-08-10',
        reportType: 'Monitoring Update',
        notes: 'Monthly monitoring update',
        createdBy: 'Lisa Brown',
        createdAt: '2025-08-10T10:30:00Z'
      },
      {
        id: '6',
        clientId: '2',
        bureau: 'TransUnion',
        score: 615,
        date: '2025-07-10',
        reportType: 'Soft Pull',
        notes: 'Quarterly credit review',
        createdBy: 'Lisa Brown',
        createdAt: '2025-07-10T16:20:00Z'
      }
    ],
    tradelines: [
      {
        id: '3',
        accountName: 'Student Credit Card',
        accountType: 'Credit Card',
        status: 'Open',
        balance: 420,
        creditLimit: 1000,
        dateOpened: '2024-09-15',
        paymentHistory: '98% On-Time',
        accountNumber: '****9876',
        creditor: 'Chase'
      },
      {
        id: '4',
        accountName: 'Cash Back Card',
        accountType: 'Credit Card',
        status: 'Open',
        balance: 680,
        creditLimit: 2000,
        dateOpened: '2025-03-01',
        paymentHistory: '100% On-Time',
        accountNumber: '****5432',
        creditor: 'Discover'
      }
    ],
    notes: 'Marcus is a college student who has been building credit for about a year. He\'s shown excellent discipline with his spending and payment habits. Current utilization is a bit high - working on paying down balances to under 30%. Good candidate for a higher limit increase once utilization improves.',
    creditDevelopmentForm: {
      creditDevelopmentStartDate: '2024-09-01',
      creditDevelopmentEndDate: '2025-06-30',
      initialReview: true,
      initialReviewDate: '2024-09-15',
      authorizedUser1: 'Parent - AMEX Gold',
      authorizedUser1DateAdded: '2024-10-01',
      securedCardType: 'discover_secured',
      creditDevelopmentStage: 'graduate_to_unsecured',
      amexApplicationType: 'amex_everyday',
      finalReview: true,
      applicationSubmissionDate: '2025-09-01',
      authorizedUser2: 'Parent - Chase Freedom',
      authorizedUser2DateAdded: '2025-02-15',
      authorizedUserSection: {
        authorizedUserStage: 'completed',
        authorizedUserStartDate: '2024-09-15',
        authorizedUserEndDate: '2025-09-01'
      }
    }
  }
];

export const mockUsers: User[] = [
  {
    id: '1',
    email: 'admin@regal.com',
    firstName: 'System',
    lastName: 'Administrator',
    role: 'system_admin',
    department: 'all',
    permissions: [
      { resource: 'users', level: 'admin' },
      { resource: 'clients', level: 'admin' },
      { resource: 'tasks', level: 'admin' },
      { resource: 'reports', level: 'admin' },
      { resource: 'settings', level: 'admin' }
    ],
    isActive: true,
    lastLogin: '2025-09-20',
    createdDate: '2025-01-01',
    createdBy: 'system',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=32&h=32&fit=crop&crop=face',
    phoneNumber: '(555) 000-0001',
    title: 'System Administrator'
  },
  {
    id: '2',
    email: 'sarah.johnson@regal.com',
    firstName: 'Sarah',
    lastName: 'Johnson',
    role: 'product_manager',
    department: 'credit_management',
    permissions: [
      { resource: 'clients', level: 'admin' },
      { resource: 'tasks', level: 'admin' },
      { resource: 'reports', level: 'write' },
      { resource: 'team', level: 'admin' }
    ],
    isActive: true,
    lastLogin: '2025-09-19',
    createdDate: '2025-02-15',
    createdBy: 'admin@regal.com',
    avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612045d?w=32&h=32&fit=crop&crop=face',
    phoneNumber: '(555) 123-4567',
    title: 'Credit Management Product Manager',
    manager: 'admin@regal.com',
    teams: ['credit-repair', 'credit-development']
  },
  {
    id: '3',
    email: 'mike.chen@regal.com',
    firstName: 'Mike',
    lastName: 'Chen',
    role: 'product_manager',
    department: 'cybersweep',
    permissions: [
      { resource: 'clients', level: 'admin' },
      { resource: 'tasks', level: 'admin' },
      { resource: 'reports', level: 'write' },
      { resource: 'team', level: 'admin' }
    ],
    isActive: true,
    lastLogin: '2025-09-20',
    createdDate: '2025-03-01',
    createdBy: 'admin@regal.com',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=32&h=32&fit=crop&crop=face',
    phoneNumber: '(555) 234-5678',
    title: 'CyberSweep Product Manager',
    manager: 'admin@regal.com',
    teams: ['cybersweep-auditors']
  },
  {
    id: '4',
    email: 'lisa.brown@regal.com',
    firstName: 'Lisa',
    lastName: 'Brown',
    role: 'team_user',
    department: 'credit_management',
    permissions: [
      { resource: 'clients', level: 'write' },
      { resource: 'tasks', level: 'write' },
      { resource: 'reports', level: 'read' }
    ],
    isActive: true,
    lastLogin: '2025-09-18',
    createdDate: '2025-04-10',
    createdBy: 'sarah.johnson@regal.com',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=32&h=32&fit=crop&crop=face',
    phoneNumber: '(555) 345-6789',
    title: 'Credit Repair Specialist',
    manager: 'sarah.johnson@regal.com',
    teams: ['credit-repair']
  },
  {
    id: '5',
    email: 'john.smith@regal.com',
    firstName: 'John',
    lastName: 'Smith',
    role: 'team_user',
    department: 'credit_management',
    permissions: [
      { resource: 'clients', level: 'write' },
      { resource: 'tasks', level: 'write' },
      { resource: 'reports', level: 'read' }
    ],
    isActive: true,
    lastLogin: '2025-09-19',
    createdDate: '2025-05-15',
    createdBy: 'sarah.johnson@regal.com',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=32&h=32&fit=crop&crop=face',
    phoneNumber: '(555) 456-7890',
    title: 'Credit Development Specialist',
    manager: 'sarah.johnson@regal.com',
    teams: ['credit-development']
  },
  {
    id: '6',
    email: 'emma.davis@regal.com',
    firstName: 'Emma',
    lastName: 'Davis',
    role: 'team_user',
    department: 'cybersweep',
    permissions: [
      { resource: 'clients', level: 'write' },
      { resource: 'tasks', level: 'write' },
      { resource: 'reports', level: 'read' }
    ],
    isActive: false,
    lastLogin: '2025-09-10',
    createdDate: '2025-06-01',
    createdBy: 'mike.chen@regal.com',
    avatar: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=32&h=32&fit=crop&crop=face',
    phoneNumber: '(555) 567-8901',
    title: 'CyberSweep Auditor',
    manager: 'mike.chen@regal.com',
    teams: ['cybersweep-auditors']
  }
];

export const mockInvitations: UserInvitation[] = [
  {
    id: '1',
    email: 'david.wilson@regal.com',
    role: 'team_user',
    department: 'credit_block',
    invitedBy: 'admin@regal.com',
    invitedDate: '2025-09-18',
    expiresDate: '2025-09-25',
    status: 'pending',
    permissions: [
      { resource: 'clients', level: 'write' },
      { resource: 'tasks', level: 'write' },
      { resource: 'reports', level: 'read' }
    ]
  },
  {
    id: '2',
    email: 'rachel.martinez@regal.com',
    role: 'product_manager',
    department: 'credit_block',
    invitedBy: 'admin@regal.com',
    invitedDate: '2025-09-17',
    expiresDate: '2025-09-24',
    status: 'pending',
    permissions: [
      { resource: 'clients', level: 'admin' },
      { resource: 'tasks', level: 'admin' },
      { resource: 'reports', level: 'write' },
      { resource: 'team', level: 'admin' }
    ]
  }
];

export const mockRoleTemplates: RoleTemplate[] = [
  {
    id: 'system_admin',
    name: 'System Administrator',
    description: 'Full system access with user management and system configuration capabilities',
    defaultPermissions: [
      { resource: 'users', level: 'admin' },
      { resource: 'clients', level: 'admin' },
      { resource: 'tasks', level: 'admin' },
      { resource: 'reports', level: 'admin' },
      { resource: 'settings', level: 'admin' }
    ],
    canInviteUsers: true,
    canAssignTasks: true,
    canCreateReports: true,
    canModifyUI: true,
    canAccessAllDepartments: true
  },
  {
    id: 'product_manager',
    name: 'Product Manager',
    description: 'Department oversight with team management and reporting capabilities',
    defaultPermissions: [
      { resource: 'clients', level: 'admin' },
      { resource: 'tasks', level: 'admin' },
      { resource: 'reports', level: 'write' },
      { resource: 'team', level: 'admin' }
    ],
    canInviteUsers: true,
    canAssignTasks: true,
    canCreateReports: true,
    canModifyUI: false,
    canAccessAllDepartments: false
  },
  {
    id: 'team_user',
    name: 'Team User',
    description: 'Standard user access with task management and client interaction capabilities',
    defaultPermissions: [
      { resource: 'clients', level: 'write' },
      { resource: 'tasks', level: 'write' },
      { resource: 'reports', level: 'read' }
    ],
    canInviteUsers: false,
    canAssignTasks: false,
    canCreateReports: false,
    canModifyUI: false,
    canAccessAllDepartments: false
  }
];

export const mockAuditLogs: AuditLog[] = [
  {
    id: '1',
    userId: '1',
    action: 'user_created',
    resource: 'users',
    resourceId: '6',
    changes: { email: 'emma.davis@regal.com', role: 'team_user' },
    timestamp: '2025-09-20T10:30:00Z',
    ipAddress: '192.168.1.100'
  },
  {
    id: '2',
    userId: '2',
    action: 'user_deactivated',
    resource: 'users',
    resourceId: '6',
    changes: { isActive: false },
    timestamp: '2025-09-19T14:22:00Z',
    ipAddress: '192.168.1.105'
  },
  {
    id: '3',
    userId: '1',
    action: 'invitation_sent',
    resource: 'invitations',
    resourceId: '1',
    changes: { email: 'david.wilson@regal.com', role: 'team_user' },
    timestamp: '2025-09-18T09:15:00Z',
    ipAddress: '192.168.1.100'
  },
  {
    id: '4',
    userId: '3',
    action: 'task_assigned',
    resource: 'tasks',
    resourceId: '7',
    changes: { assignee: 'emma.davis@regal.com' },
    timestamp: '2025-09-17T16:45:00Z',
    ipAddress: '192.168.1.110'
  },
  {
    id: '5',
    userId: '2',
    action: 'role_updated',
    resource: 'users',
    resourceId: '4',
    changes: { role: 'team_user', permissions: 'updated' },
    timestamp: '2025-09-16T11:30:00Z',
    ipAddress: '192.168.1.105'
  }
];

// UI Configuration Mock Data
export const mockFieldConfigs: FieldConfig[] = [
  // Global/Shared Fields
  {
    id: 'global_first_name',
    name: 'firstName',
    label: 'First Name',
    type: 'text',
    description: 'Person\'s first name',
    isRequired: true,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'global',
    objectType: 'person',
    validation: { required: true, maxLength: 50 },
    displayOrder: 1,
    columnWidth: 6,
    section: 'basic_info',
    isShared: true,
    sharedWith: ['regal', 'credit_management', 'cybersweep', 'credit_block'],
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'global_last_name',
    name: 'lastName',
    label: 'Last Name',
    type: 'text',
    description: 'Person\'s last name',
    isRequired: true,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'global',
    objectType: 'person',
    validation: { required: true, maxLength: 50 },
    displayOrder: 2,
    columnWidth: 6,
    section: 'basic_info',
    isShared: true,
    sharedWith: ['regal', 'credit_management', 'cybersweep', 'credit_block'],
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'global_email',
    name: 'email',
    label: 'Email Address',
    type: 'email',
    description: 'Primary email address',
    isRequired: true,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'global',
    objectType: 'person',
    validation: { required: true },
    displayOrder: 3,
    columnWidth: 12,
    section: 'contact_info',
    isShared: true,
    sharedWith: ['regal', 'credit_management', 'cybersweep', 'credit_block'],
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'global_phone',
    name: 'phone',
    label: 'Phone Number',
    type: 'phone',
    description: 'Primary phone number',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'global',
    objectType: 'person',
    displayOrder: 4,
    columnWidth: 6,
    section: 'contact_info',
    isShared: true,
    sharedWith: ['regal', 'credit_management', 'cybersweep', 'credit_block'],
    createdBy: 'system',
    createdDate: '2025-01-01'
  },

  // Regal/Client Management Fields
  {
    id: 'client_status',
    name: 'status',
    label: 'Client Status',
    type: 'select',
    description: 'Current client status',
    isRequired: true,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'regal',
    objectType: 'client',
    options: [
      { value: 'active', label: 'Active', color: 'green', isDefault: true, isActive: true },
      { value: 'pending', label: 'Pending', color: 'yellow', isDefault: false, isActive: true },
      { value: 'inactive', label: 'Inactive', color: 'gray', isDefault: false, isActive: true },
      { value: 'suspended', label: 'Suspended', color: 'red', isDefault: false, isActive: true }
    ],
    displayOrder: 5,
    columnWidth: 6,
    section: 'basic_info',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },

  // Credit Management Specific Fields
  {
    id: 'credit_score',
    name: 'creditScore',
    label: 'Current Credit Score',
    type: 'number',
    description: 'Most recent credit score',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: true,
    applicationId: 'credit_management',
    objectType: 'client',
    validation: { min: 300, max: 850 },
    displayOrder: 1,
    columnWidth: 4,
    section: 'credit_info',
    createdBy: 'admin@regal.com',
    createdDate: '2025-03-15'
  },
  {
    id: 'credit_bureau_provider',
    name: 'creditBureauProvider',
    label: 'Credit Bureau Provider',
    type: 'select',
    description: 'Primary credit bureau used',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'credit_management',
    objectType: 'client',
    options: [
      { value: 'experian', label: 'Experian', isActive: true },
      { value: 'equifax', label: 'Equifax', isActive: true },
      { value: 'transunion', label: 'TransUnion', isActive: true }
    ],
    displayOrder: 2,
    columnWidth: 4,
    section: 'credit_info',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'credit_repair_stage',
    name: 'creditRepairStage',
    label: 'Credit Repair Stage',
    type: 'select',
    description: 'Current stage in credit repair process',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'credit_management',
    objectType: 'client',
    options: [
      { value: 'analysis', label: 'Credit Analysis', isActive: true },
      { value: 'disputes', label: 'Filing Disputes', isActive: true },
      { value: 'monitoring', label: 'Monitoring Progress', isActive: true },
      { value: 'optimization', label: 'Score Optimization', isActive: true },
      { value: 'completed', label: 'Process Completed', isActive: true }
    ],
    displayOrder: 3,
    columnWidth: 4,
    section: 'credit_info',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },

  // CyberSweep Specific Fields - Client Details
  {
    id: 'cybersweep_start_date',
    name: 'cyberSweepStartDate',
    label: 'Cyber Sweep Start Date',
    type: 'date',
    description: 'Start date of CyberSweep service',
    isRequired: true,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 1,
    columnWidth: 6,
    section: 'cybersweep_client_info',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_end_date',
    name: 'cyberSweepEndDate',
    label: 'Cyber Sweep End Date',
    type: 'date',
    description: 'End date of CyberSweep service',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 2,
    columnWidth: 6,
    section: 'cybersweep_client_info',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_stage',
    name: 'cyberSweepStage',
    label: 'Cyber Sweep Stage',
    type: 'select',
    description: 'Current stage of CyberSweep process',
    isRequired: true,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    options: [
      { value: 'Active Monitoring', label: 'Active Monitoring', isActive: true },
      { value: 'Initial Setup', label: 'Initial Setup', isActive: true },
      { value: 'Review', label: 'Review', isActive: true },
      { value: 'Completed', label: 'Completed', isActive: true },
      { value: 'On Hold', label: 'On Hold', isActive: true }
    ],
    displayOrder: 3,
    columnWidth: 6,
    section: 'cybersweep_client_info',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_client_status',
    name: 'cyberSweepStatus',
    label: 'Cyber Sweep Status',
    type: 'select',
    description: 'Current status of CyberSweep service',
    isRequired: true,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    options: [
      { value: 'In Progress', label: 'In Progress', color: 'blue', isActive: true },
      { value: 'Pending', label: 'Pending', color: 'yellow', isActive: true },
      { value: 'Completed', label: 'Completed', color: 'green', isActive: true },
      { value: 'Cancelled', label: 'Cancelled', color: 'red', isActive: true }
    ],
    displayOrder: 4,
    columnWidth: 6,
    section: 'cybersweep_client_info',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_cs_reports_recipients',
    name: 'csReportsRecipients',
    label: 'CS Reports Recipients',
    type: 'textarea',
    description: 'Email addresses for CS reports (comma-separated)',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 5,
    columnWidth: 12,
    section: 'cybersweep_reports',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_initial_report',
    name: 'initialReport',
    label: 'Initial Report',
    type: 'checkbox',
    description: 'Initial report completed',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 6,
    columnWidth: 6,
    section: 'cybersweep_reports',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_initial_report_date',
    name: 'initialReportDate',
    label: 'Initial Report Date',
    type: 'date',
    description: 'Date initial report was completed',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 7,
    columnWidth: 6,
    section: 'cybersweep_reports',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_final_report',
    name: 'finalReport',
    label: 'Final Report',
    type: 'checkbox',
    description: 'Final report completed',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 8,
    columnWidth: 6,
    section: 'cybersweep_reports',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_final_report_date',
    name: 'finalReportDate',
    label: 'Final Report Date',
    type: 'date',
    description: 'Date final report was completed',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 9,
    columnWidth: 6,
    section: 'cybersweep_reports',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_quarterly_sweep_1',
    name: 'quarterlySweep1',
    label: 'Quarterly Sweep 1',
    type: 'checkbox',
    description: 'First quarterly sweep completed',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 10,
    columnWidth: 6,
    section: 'cybersweep_sweeps',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_sweep1_date',
    name: 'sweep1Date',
    label: 'Sweep 1 Date',
    type: 'date',
    description: 'Date of first quarterly sweep',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 11,
    columnWidth: 6,
    section: 'cybersweep_sweeps',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_quarterly_sweep_2',
    name: 'quarterlySweep2',
    label: 'Quarterly Sweep 2',
    type: 'checkbox',
    description: 'Second quarterly sweep completed',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 12,
    columnWidth: 6,
    section: 'cybersweep_sweeps',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_sweep2_date',
    name: 'sweep2Date',
    label: 'Sweep 2 Date',
    type: 'date',
    description: 'Date of second quarterly sweep',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 13,
    columnWidth: 6,
    section: 'cybersweep_sweeps',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_quarterly_sweep_3',
    name: 'quarterlySweep3',
    label: 'Quarterly Sweep 3',
    type: 'checkbox',
    description: 'Third quarterly sweep completed',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 14,
    columnWidth: 6,
    section: 'cybersweep_sweeps',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_sweep3_date',
    name: 'sweep3Date',
    label: 'Sweep 3 Date',
    type: 'date',
    description: 'Date of third quarterly sweep',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 15,
    columnWidth: 6,
    section: 'cybersweep_sweeps',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_quarterly_sweep_4',
    name: 'quarterlySweep4',
    label: 'Quarterly Sweep 4',
    type: 'checkbox',
    description: 'Fourth quarterly sweep completed',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 16,
    columnWidth: 6,
    section: 'cybersweep_sweeps',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_sweep4_date',
    name: 'sweep4Date',
    label: 'Sweep 4 Date',
    type: 'date',
    description: 'Date of fourth quarterly sweep',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 17,
    columnWidth: 6,
    section: 'cybersweep_sweeps',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_profession',
    name: 'profession',
    label: 'Profession',
    type: 'text',
    description: 'Client profession',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 18,
    columnWidth: 6,
    section: 'cybersweep_professional',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_other_profession',
    name: 'otherProfession',
    label: 'Other Profession',
    type: 'text',
    description: 'Additional profession details',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 19,
    columnWidth: 6,
    section: 'cybersweep_professional',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },

  // CyberSweep Audit Fields
  {
    id: 'cybersweep_audit_id',
    name: 'auditId',
    label: 'Audit ID',
    type: 'auto-number',
    description: 'Unique audit identifier',
    isRequired: true,
    isReadOnly: true,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'audit',
    displayOrder: 1,
    columnWidth: 6,
    section: 'audit_info',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_audit_phase',
    name: 'auditPhase',
    label: 'Audit Phase',
    type: 'select',
    description: 'Current audit phase/quarter',
    isRequired: true,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'audit',
    options: [
      { value: 'Q1_2025', label: 'Q1 2025', isActive: true },
      { value: 'Q2_2025', label: 'Q2 2025', isActive: true },
      { value: 'Q3_2025', label: 'Q3 2025', isActive: true },
      { value: 'Q4_2025', label: 'Q4 2025', isActive: true }
    ],
    displayOrder: 2,
    columnWidth: 6,
    section: 'audit_info',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_auditor_assigned',
    name: 'auditorAssigned',
    label: 'Assigned Auditor',
    type: 'lookup',
    description: 'Auditor assigned to this case',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'audit',
    lookupConfig: {
      targetObject: 'user',
      displayField: 'fullName',
      valueField: 'id',
      filterFields: ['department=cybersweep']
    },
    displayOrder: 3,
    columnWidth: 6,
    section: 'audit_info',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_pii_removal_count',
    name: 'piiRemovalCount',
    label: 'PII Items Removed',
    type: 'number',
    description: 'Number of PII items successfully removed',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: true,
    applicationId: 'cybersweep',
    objectType: 'audit',
    validation: { min: 0 },
    displayOrder: 4,
    columnWidth: 4,
    section: 'results_info',
    createdBy: 'mike.chen@regal.com',
    createdDate: '2025-04-01'
  },
  {
    id: 'cybersweep_status',
    name: 'auditStatus',
    label: 'Audit Status',
    type: 'select',
    description: 'Current status of the audit',
    isRequired: true,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'audit',
    options: [
      { value: 'not_started', label: 'Not Started', color: 'gray', isActive: true },
      { value: 'in_progress', label: 'In Progress', color: 'blue', isActive: true },
      { value: 'ready_for_report', label: 'Ready for Report', color: 'green', isActive: true },
      { value: 'completed', label: 'Completed', color: 'green', isActive: true },
      { value: 'on_hold', label: 'On Hold', color: 'yellow', isActive: true }
    ],
    displayOrder: 5,
    columnWidth: 4,
    section: 'audit_info',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },

  // Credit Block Specific Fields
  {
    id: 'credit_block_freeze_status',
    name: 'freezeStatus',
    label: 'Credit Freeze Status',
    type: 'select',
    description: 'Status of credit bureau freeze',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'credit_block',
    objectType: 'freeze',
    options: [
      { value: 'active', label: 'Active Freeze', color: 'red', isActive: true },
      { value: 'temporary_lift', label: 'Temporary Lift', color: 'yellow', isActive: true },
      { value: 'removed', label: 'Freeze Removed', color: 'green', isActive: true },
      { value: 'pending', label: 'Pending Setup', color: 'blue', isActive: true }
    ],
    displayOrder: 1,
    columnWidth: 6,
    section: 'freeze_info',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'credit_block_bureau',
    name: 'creditBureau',
    label: 'Credit Bureau',
    type: 'multiselect',
    description: 'Credit bureaus where freeze is active',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'credit_block',
    objectType: 'freeze',
    options: [
      { value: 'experian', label: 'Experian', isActive: true },
      { value: 'equifax', label: 'Equifax', isActive: true },
      { value: 'transunion', label: 'TransUnion', isActive: true },
      { value: 'innovis', label: 'Innovis', isActive: true }
    ],
    displayOrder: 2,
    columnWidth: 6,
    section: 'freeze_info',
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'credit_block_pin',
    name: 'freezePin',
    label: 'Freeze PIN',
    type: 'text',
    description: 'Security PIN for freeze management',
    isRequired: false,
    isReadOnly: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'credit_block',
    objectType: 'freeze',
    validation: { maxLength: 20 },
    displayOrder: 3,
    columnWidth: 4,
    section: 'security_info',
    createdBy: 'system',
    createdDate: '2025-01-01'
  }
];

export const mockSectionConfigs: SectionConfig[] = [
  // Global/Shared Sections
  {
    id: 'basic_info',
    name: 'basicInfo',
    label: 'Basic Information',
    description: 'Essential personal details',
    isCollapsible: false,
    isCollapsedByDefault: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'global',
    objectType: 'person',
    displayOrder: 1,
    columns: 2,
    isShared: true,
    sharedWith: ['regal', 'credit_management', 'cybersweep', 'credit_block'],
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'contact_info',
    name: 'contactInfo',
    label: 'Contact Information',
    description: 'Phone, email, and address details',
    isCollapsible: true,
    isCollapsedByDefault: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'global',
    objectType: 'person',
    displayOrder: 2,
    columns: 2,
    isShared: true,
    sharedWith: ['regal', 'credit_management', 'cybersweep', 'credit_block'],
    createdBy: 'system',
    createdDate: '2025-01-01'
  },

  // Credit Management Sections
  {
    id: 'credit_info',
    name: 'creditInfo',
    label: 'Credit Information',
    description: 'Credit scores, bureaus, and repair stages',
    isCollapsible: true,
    isCollapsedByDefault: false,
    isVisible: true,
    isCustom: true,
    applicationId: 'credit_management',
    objectType: 'client',
    displayOrder: 3,
    columns: 3,
    createdBy: 'admin@regal.com',
    createdDate: '2025-03-15'
  },
  {
    id: 'service_info',
    name: 'serviceInfo',
    label: 'Service Information',
    description: 'Enrolled services and dates',
    isCollapsible: true,
    isCollapsedByDefault: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'regal',
    objectType: 'client',
    displayOrder: 4,
    columns: 2,
    createdBy: 'system',
    createdDate: '2025-01-01'
  },

  // CyberSweep Sections - Client
  {
    id: 'cybersweep_client_info',
    name: 'cyberSweepClientInfo',
    label: 'CyberSweep Client Information',
    description: 'CyberSweep service details and status',
    isCollapsible: false,
    isCollapsedByDefault: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 1,
    columns: 2,
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_reports',
    name: 'cyberSweepReports',
    label: 'Reports',
    description: 'Initial and final report tracking',
    isCollapsible: true,
    isCollapsedByDefault: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 2,
    columns: 2,
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_sweeps',
    name: 'cyberSweepSweeps',
    label: 'Quarterly Sweeps',
    description: 'Quarterly sweep tracking',
    isCollapsible: true,
    isCollapsedByDefault: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 3,
    columns: 2,
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_professional',
    name: 'cyberSweepProfessional',
    label: 'Professional Information',
    description: 'Client profession details',
    isCollapsible: true,
    isCollapsedByDefault: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'client',
    displayOrder: 4,
    columns: 2,
    createdBy: 'system',
    createdDate: '2025-01-01'
  },

  // CyberSweep Sections - Audit
  {
    id: 'audit_info',
    name: 'auditInfo',
    label: 'Audit Information',
    description: 'Audit details, phase, and assignment',
    isCollapsible: false,
    isCollapsedByDefault: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'audit',
    displayOrder: 1,
    columns: 2,
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'results_info',
    name: 'resultsInfo',
    label: 'Audit Results',
    description: 'PII removal results and statistics',
    isCollapsible: true,
    isCollapsedByDefault: false,
    isVisible: true,
    isCustom: true,
    applicationId: 'cybersweep',
    objectType: 'audit',
    displayOrder: 2,
    columns: 3,
    createdBy: 'mike.chen@regal.com',
    createdDate: '2025-04-01'
  },

  // Credit Block Sections
  {
    id: 'freeze_info',
    name: 'freezeInfo',
    label: 'Credit Freeze Information',
    description: 'Credit freeze status and bureau details',
    isCollapsible: false,
    isCollapsedByDefault: false,
    isVisible: true,
    isCustom: false,
    applicationId: 'credit_block',
    objectType: 'freeze',
    displayOrder: 1,
    columns: 2,
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'security_info',
    name: 'securityInfo',
    label: 'Security Information',
    description: 'PINs and security details for freeze management',
    isCollapsible: true,
    isCollapsedByDefault: true,
    isVisible: true,
    isCustom: false,
    applicationId: 'credit_block',
    objectType: 'freeze',
    displayOrder: 2,
    columns: 1,
    createdBy: 'system',
    createdDate: '2025-01-01'
  }
];

export const mockTabConfigs: TabConfig[] = [
  // Regal App Tabs
  {
    id: 'overview_tab',
    name: 'overview',
    label: 'Overview',
    icon: 'User',
    description: 'Client overview and basic information',
    isVisible: true,
    isCustom: false,
    applicationId: 'regal',
    objectType: 'client',
    displayOrder: 1,
    permissions: {
      view: ['system_admin', 'product_manager', 'team_user'],
      edit: ['system_admin', 'product_manager', 'team_user']
    },
    sections: ['basic_info', 'contact_info', 'service_info'],
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'credit_tab',
    name: 'credit',
    label: 'Credit Details',
    icon: 'CreditCard',
    description: 'Credit scores, reports, and history',
    isVisible: true,
    isCustom: true,
    applicationId: 'regal',
    objectType: 'client',
    displayOrder: 2,
    permissions: {
      view: ['system_admin', 'product_manager', 'team_user'],
      edit: ['system_admin', 'product_manager']
    },
    sections: ['credit_info'],
    createdBy: 'admin@regal.com',
    createdDate: '2025-03-15'
  },

  // Credit Management App Tabs
  {
    id: 'credit_repair_overview_tab',
    name: 'overview',
    label: 'Case Overview',
    icon: 'FileText',
    description: 'Credit repair case information',
    isVisible: true,
    isCustom: false,
    applicationId: 'credit_management',
    objectType: 'case',
    displayOrder: 1,
    permissions: {
      view: ['system_admin', 'product_manager', 'team_user'],
      edit: ['system_admin', 'product_manager', 'team_user']
    },
    sections: ['basic_info', 'contact_info', 'repair_info'],
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'credit_reports_tab',
    name: 'reports',
    label: 'Credit Reports',
    icon: 'BarChart',
    description: 'Credit bureau reports and scores',
    isVisible: true,
    isCustom: false,
    applicationId: 'credit_management',
    objectType: 'case',
    displayOrder: 2,
    permissions: {
      view: ['system_admin', 'product_manager', 'team_user'],
      edit: ['system_admin', 'product_manager']
    },
    sections: ['credit_info', 'bureau_info'],
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'disputes_tab',
    name: 'disputes',
    label: 'Disputes',
    icon: 'AlertTriangle',
    description: 'Active and resolved disputes',
    isVisible: true,
    isCustom: true,
    applicationId: 'credit_management',
    objectType: 'case',
    displayOrder: 3,
    permissions: {
      view: ['system_admin', 'product_manager', 'team_user'],
      edit: ['system_admin', 'product_manager']
    },
    sections: ['dispute_info'],
    createdBy: 'mike.chen@regal.com',
    createdDate: '2025-04-10'
  },

  // CyberSweep App Tabs
  {
    id: 'cybersweep_audit_tab',
    name: 'audit',
    label: 'Audit Details',
    icon: 'Search',
    description: 'PII audit information and results',
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'audit',
    displayOrder: 1,
    permissions: {
      view: ['system_admin', 'product_manager', 'team_user'],
      edit: ['system_admin', 'product_manager', 'team_user']
    },
    sections: ['basic_info', 'contact_info', 'audit_info'],
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_results_tab',
    name: 'results',
    label: 'Audit Results',
    icon: 'CheckCircle',
    description: 'PII removal results and status',
    isVisible: true,
    isCustom: false,
    applicationId: 'cybersweep',
    objectType: 'audit',
    displayOrder: 2,
    permissions: {
      view: ['system_admin', 'product_manager', 'team_user'],
      edit: ['system_admin', 'product_manager']
    },
    sections: ['results_info', 'removal_info'],
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'cybersweep_timeline_tab',
    name: 'timeline',
    label: 'Timeline',
    icon: 'Clock',
    description: 'Audit timeline and milestones',
    isVisible: true,
    isCustom: true,
    applicationId: 'cybersweep',
    objectType: 'audit',
    displayOrder: 3,
    permissions: {
      view: ['system_admin', 'product_manager', 'team_user'],
      edit: ['system_admin', 'product_manager']
    },
    sections: ['timeline_info'],
    createdBy: 'lisa.brown@regal.com',
    createdDate: '2025-05-20'
  },

  // Credit Block App Tabs
  {
    id: 'credit_block_overview_tab',
    name: 'overview',
    label: 'Block Overview',
    icon: 'Shield',
    description: 'Credit freeze and protection overview',
    isVisible: true,
    isCustom: false,
    applicationId: 'credit_block',
    objectType: 'freeze',
    displayOrder: 1,
    permissions: {
      view: ['system_admin', 'product_manager', 'team_user'],
      edit: ['system_admin', 'product_manager', 'team_user']
    },
    sections: ['basic_info', 'contact_info', 'freeze_info'],
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'credit_block_bureaus_tab',
    name: 'bureaus',
    label: 'Credit Bureaus',
    icon: 'Building',
    description: 'Bureau-specific freeze status and settings',
    isVisible: true,
    isCustom: false,
    applicationId: 'credit_block',
    objectType: 'freeze',
    displayOrder: 2,
    permissions: {
      view: ['system_admin', 'product_manager', 'team_user'],
      edit: ['system_admin', 'product_manager']
    },
    sections: ['bureau_info', 'security_info'],
    createdBy: 'system',
    createdDate: '2025-01-01'
  },
  {
    id: 'credit_block_history_tab',
    name: 'history',
    label: 'Freeze History',
    icon: 'History',
    description: 'History of freeze changes and activities',
    isVisible: true,
    isCustom: true,
    applicationId: 'credit_block',
    objectType: 'freeze',
    displayOrder: 3,
    permissions: {
      view: ['system_admin', 'product_manager', 'team_user'],
      edit: ['system_admin', 'product_manager']
    },
    sections: ['history_info'],
    createdBy: 'david.kim@regal.com',
    createdDate: '2025-06-01'
  }
];

export const mockUIConfigChangeLogs: UIConfigChangeLog[] = [
  {
    id: '1',
    changeType: 'field_added',
    objectType: 'client',
    objectId: 'client_credit_score',
    newValue: {
      name: 'creditScore',
      label: 'Current Credit Score',
      type: 'number'
    },
    changedBy: 'admin@regal.com',
    changeDate: '2025-03-15T10:30:00Z',
    reason: 'Business requirement to track credit scores more effectively',
    impact: 'medium'
  },
  {
    id: '2',
    changeType: 'section_added',
    objectType: 'client',
    objectId: 'credit_info',
    newValue: {
      name: 'creditInfo',
      label: 'Credit Information',
      columns: 3
    },
    changedBy: 'admin@regal.com',
    changeDate: '2025-03-15T10:35:00Z',
    reason: 'Organize credit-related fields in dedicated section',
    impact: 'low'
  },
  {
    id: '3',
    changeType: 'field_modified',
    objectType: 'client',
    objectId: 'client_status',
    oldValue: {
      options: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' }
      ]
    },
    newValue: {
      options: [
        { value: 'active', label: 'Active' },
        { value: 'pending', label: 'Pending' },
        { value: 'inactive', label: 'Inactive' },
        { value: 'suspended', label: 'Suspended' }
      ]
    },
    changedBy: 'sarah.johnson@regal.com',
    changeDate: '2025-09-10T14:20:00Z',
    reason: 'Added pending and suspended status options for better client tracking',
    impact: 'medium'
  },
  {
    id: '4',
    changeType: 'tab_added',
    objectType: 'client',
    objectId: 'credit_tab',
    newValue: {
      name: 'credit',
      label: 'Credit Details',
      sections: ['credit_info']
    },
    changedBy: 'admin@regal.com',
    changeDate: '2025-03-15T11:00:00Z',
    reason: 'Separate credit information into dedicated tab for better organization',
    impact: 'high'
  }
];